import { createSelector } from "reselect";
import { RootState } from "../../state";
import { CompanyValueFeature } from "../api/index";

export interface CategorizedCompanyValueFeature {
  category: string;
  features: CompanyValueFeature[];
}

export const featuresSelector = (state: RootState) => state.company_values.features.list;

export const categorizedFeaturesSelector = createSelector(
  (state: RootState) => featuresSelector(state),
  features => {
    return features.reduce(
      (acc, feat) => {
        let cat = acc.find(cat => cat.category === feat.feature_category);
        if (!cat) {
          cat = { category: feat.feature_category, features: [] };
          acc.push(cat);
        }
        cat.features.push(feat);
        return acc;
      },
      [] as CategorizedCompanyValueFeature[]
    );
  }
);

export const companiesSelector = (state: RootState) => state.company_values.search.companies;



// WEBPACK FOOTER //
// ./frontend/src/company_values/selectors/index.ts